import type { VolumeCapacityConfig } from '@/features/bidding/types/bidLadderInput'

export const MAX_BID_LEVELS_MFRR = 3
export const MAX_BID_LEVELS_FCR = 6

// Default prices for each level (index 0 = level 1 at bottom, increasing upward)
export const DEFAULT_PRICES_MFRR = [0.99, 1.99, 10]
export const DEFAULT_PRICES_FCR = [0.5, 1.5, 2.5, 3.5, 4.5, 5.5]

export function createDefaultVolumeCapacityConfig(): VolumeCapacityConfig {
  return { value: null, mode: 'fixed' }
}
